import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getNotificationsCountKey } from '../../utils/keys';
export const useNotificationsCount = (options) => {
    const { useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const notificationsKey = getNotificationsCountKey();
    return useQuery(notificationsKey, () => client === null || client === void 0 ? void 0 : client.notifications.count(), useQueryOptions);
};
//# sourceMappingURL=useNotificationsCount.js.map